import { ReportData } from "model/reportData.model"
import { RoomOccupationReport } from "model/reports/roomOccupation.report.model"
import { toDateMonthYearHourMinuteString } from "utils/date.util"

export function createRoomOccupationReportData(data?: RoomOccupationReport[]): ReportData {
    const rows: string[][] = []
    
    if(data && data.length > 0){
        // Processar em lotes para evitar stack overflow com arrays grandes
        const batchSize = 10000
        for(let i = 0; i < data.length; i += batchSize){
            const batch = data.slice(i, Math.min(i + batchSize, data.length))
            for(const item of batch){
                rows.push([
                    item.building ?? '---',
                    item.area ?? '---',
                    item.room ?? '---',
                    toDateMonthYearHourMinuteString(item.date) ?? '---',
                    (item.occupied === undefined || item.occupied === null) 
                        ? '---' 
                        : (item.occupied ? 'Ocupada' : 'Não ocupada')
                ])
            }
        }
    }
    
    return {
        titles: ['Prédio', 'Andar', 'Sala', 'Data', 'Status'],
        rows: rows
    }
}